import { render, staticRenderFns } from "./addComment.vue?vue&type=template&id=a647b160&scoped=true"
import script from "./addComment.vue?vue&type=script&lang=ts"
export * from "./addComment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a647b160",
  null
  
)

export default component.exports